var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeFavoriteBlueLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.18 56.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#152440;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.59 2.26 38.07 19.44 57.03 22.2 43.31 35.57 46.55 54.46 29.59 45.54 12.63 54.46 15.87 35.57 2.15 22.2 21.11 19.44 29.59 2.26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeFavoriteBlueLine);
export default __webpack_public_path__ + "static/media/icone_favorite_blue_line.1497cb6ab627fa7efc52a978b1de0507.svg";
export { ForwardRef as ReactComponent };